var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-field"},[_c('label',{staticClass:"form-field-label"},[_c('span',[_vm._v(_vm._s(_vm.label))]),_vm._t("default")],2),(_vm.hint)?_c('div',{staticClass:"form-field-hint"},[_vm._v(" "+_vm._s(_vm.hint)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }